import { css, keyframes } from '@emotion/react';
import { theme } from '@frontend/theme';
import { OffsetStyle } from '../types';
import { getOffsetStyles } from '../utils';

interface HotspotNudgeProps {
  size?: number;
  color?: string;
  className?: string;
  offset?: OffsetStyle;
}

const dissolve = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
`;

export function HotspotNudge({
  size = 16,
  color = theme.colors.secondary.seaweed40,
  className,
  offset,
}: HotspotNudgeProps) {
  const offsetStyles = getOffsetStyles(offset);

  return (
    <span
      className={className}
      style={offsetStyles}
      css={[
        css({
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: `${size}px`,
          height: `${size}px`,
          zIndex: theme.zIndex.high,
          pointerEvents: 'none',
        }),
        css`
          &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background-color: ${theme.colors.secondary.seaweed50};
            opacity: 0.5;
            filter: blur(2px);
            animation: ${dissolve} 2s ease-out 200ms infinite;
          }

          &::after {
            content: '';
            position: relative;
            width: 75%;
            height: 75%;
            border-radius: 50%;
            background-color: ${color};
          }
        `,
      ]}
    />
  );
}
